export const productList = [
  /* MagSafe형 iPhone 16 시리즈 투명 케이스 */
  {
    id: 1,
    product_name: `MagSafe형 iPhone 16 투명 케이스`,
    price: 69000,
    model_code: "A3243",
    overview: [
      "얇고 가벼운 데다 탁월한 그립감을 선사하는 Apple 제작 투명 케이스는 iPhone 16의 아름다운 색상을 그대로 보여 주면서도 폰을 철저히 보호해 줍니다.",
      "투명한 폴리카보네이트와 유연한 소재로 혼합 제작된 이 케이스는 버튼을 딱 맞게 감싸도록 디자인되어 있어 사용이 편리합니다. 또, 이 케이스는 ‘카메라 컨트롤'을 원활하게 사용할 수 있습니다. 사파이어 크리스털에 전도층 처리가 되어 있어 손가락의 작은 움직임까지 카메라 컨트롤에 정확히 전달되죠.",
      "표면은 외부뿐 아니라 내부까지도 긁힘 방지 코팅이 적용되어 있습니다. 또한, 황변 방지에 최적화된 소재와 코팅 덕분에 시간이 지나도 케이스의 색상이 그대로 유지되죠.",
      "iPhone 16과 완벽하게 정렬을 이루는 내장 자석 덕분에 이 케이스는 언제나 마법 같은 탈부착 경험과 더 빠른 무선 충전 기능을 제공합니다. iPhone 충전 시에는 케이스를 씌운 채로 MagSafe 충전기를 착 붙이거나, Qi2 또는 Qi 인증 충전기에 올려 두면 되죠.",
      "모든 Apple 제작 케이스와 마찬가지로, 이 케이스 역시 설계 및 제조 과정 전반에서 수천 시간의 테스트를 거쳤습니다. 덕분에 멋진 디자인은 물론, 긁힘과 낙하 충격으로부터 iPhone을 보호할 수 있는 내구성도 갖추었죠.",
    ],
    in_the_box: [`MagSafe형 iPhone 16 투명 케이스`],
    compatible_devices: [`iPhone 16`],
    isNew: true,
    isSelectable: true,
    isMagSafe: true,
    isiPhone: true,
    badge: "New",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723935350333",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723935347103",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723935350271",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4_AV3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723935349409",
      },
      {
        id: "5",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4_AV4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723935350248",
      },
      {
        id: "6",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6A4_AV5?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724816185174",
      },
    ],
  },
  {
    id: 2,
    product_name: `MagSafe형 iPhone 16 Plus 투명 케이스`,
    price: 69000,
    model_code: "A3244",
    overview: [
      "얇고 가벼운 데다 탁월한 그립감을 선사하는 Apple 제작 투명 케이스는 iPhone 16 Plus의 아름다운 색상을 그대로 보여 주면서도 폰을 철저히 보호해 줍니다.",
      "투명한 폴리카보네이트와 유연한 소재로 혼합 제작된 이 케이스는 버튼을 딱 맞게 감싸도록 디자인되어 있어 사용이 편리합니다. 또, 이 케이스는 ‘카메라 컨트롤'을 원활하게 사용할 수 있습니다. 사파이어 크리스털에 전도층 처리가 되어 있어 손가락의 작은 움직임까지 카메라 컨트롤에 정확히 전달되죠.",
      "표면은 외부뿐 아니라 내부까지도 긁힘 방지 코팅이 적용되어 있습니다. 또한, 황변 방지에 최적화된 소재와 코팅 덕분에 시간이 지나도 케이스의 색상이 그대로 유지되죠.",
      "iPhone 16 Plus과 완벽하게 정렬을 이루는 내장 자석 덕분에 이 케이스는 언제나 마법 같은 탈부착 경험과 더 빠른 무선 충전 기능을 제공합니다. iPhone 충전 시에는 케이스를 씌운 채로 MagSafe 충전기를 착 붙이거나, Qi2 또는 Qi 인증 충전기에 올려 두면 되죠.",
      "모든 Apple 제작 케이스와 마찬가지로, 이 케이스 역시 설계 및 제조 과정 전반에서 수천 시간의 테스트를 거쳤습니다. 덕분에 멋진 디자인은 물론, 긁힘과 낙하 충격으로부터 iPhone을 보호할 수 있는 내구성도 갖추었죠.",
    ],
    in_the_box: [`MagSafe형 iPhone 16 Plus 투명 케이스`],
    compatible_devices: [`iPhone 16 Plus`],
    isNew: true,
    isSelectable: true,
    isMagSafe: true,
    isiPhone: true,
    badge: "New",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7D4_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1723162498919",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7D4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1723162498901",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7D4?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1723162499227",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7D4_AV3?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1723162498857",
      },
      {
        id: "5",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7D4_AV4?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1723162498889",
      },
    ],
  },
  {
    id: 3,
    product_name: `MagSafe형 iPhone 16 Pro 투명 케이스`,
    price: 69000,
    model_code: "A3245",
    overview: [
      "얇고 가벼운 데다 탁월한 그립감을 선사하는 Apple 제작 투명 케이스는 iPhone 16 Pro의 아름다운 색상을 그대로 보여 주면서도 폰을 철저히 보호해 줍니다.",
      "투명한 폴리카보네이트와 유연한 소재로 혼합 제작된 이 케이스는 버튼을 딱 맞게 감싸도록 디자인되어 있어 사용이 편리합니다. 또, 이 케이스는 ‘카메라 컨트롤'을 원활하게 사용할 수 있습니다. 사파이어 크리스털에 전도층 처리가 되어 있어 손가락의 작은 움직임까지 카메라 컨트롤에 정확히 전달되죠.",
      "표면은 외부뿐 아니라 내부까지도 긁힘 방지 코팅이 적용되어 있습니다. 또한, 황변 방지에 최적화된 소재와 코팅 덕분에 시간이 지나도 케이스의 색상이 그대로 유지되죠.",
      "iPhone 16 Pro과 완벽하게 정렬을 이루는 내장 자석 덕분에 이 케이스는 언제나 마법 같은 탈부착 경험과 더 빠른 무선 충전 기능을 제공합니다. iPhone 충전 시에는 케이스를 씌운 채로 MagSafe 충전기를 착 붙이거나, Qi2 또는 Qi 인증 충전기에 올려 두면 되죠.",
      "모든 Apple 제작 케이스와 마찬가지로, 이 케이스 역시 설계 및 제조 과정 전반에서 수천 시간의 테스트를 거쳤습니다. 덕분에 멋진 디자인은 물론, 긁힘과 낙하 충격으로부터 iPhone을 보호할 수 있는 내구성도 갖추었죠.",
    ],
    in_the_box: [`MagSafe형 iPhone 16 Pro 투명 케이스`],
    compatible_devices: [`iPhone 16 Pro`],
    isNew: true,
    isSelectable: true,
    isMagSafe: true,
    isiPhone: true,
    badge: "New",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930332796",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328706",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328743",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328567",
      },
      {
        id: "5",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724816499443",
      },
    ],
  },
  {
    id: 4,
    product_name: `MagSafe형 iPhone 16 Pro Max 투명 케이스`,
    price: 69000,
    model_code: "A3246",
    overview: [
      "얇고 가벼운 데다 탁월한 그립감을 선사하는 Apple 제작 투명 케이스는 iPhone 16 Pro Max의 아름다운 색상을 그대로 보여 주면서도 폰을 철저히 보호해 줍니다.",
      "투명한 폴리카보네이트와 유연한 소재로 혼합 제작된 이 케이스는 버튼을 딱 맞게 감싸도록 디자인되어 있어 사용이 편리합니다. 또, 이 케이스는 ‘카메라 컨트롤'을 원활하게 사용할 수 있습니다. 사파이어 크리스털에 전도층 처리가 되어 있어 손가락의 작은 움직임까지 카메라 컨트롤에 정확히 전달되죠.",
      "표면은 외부뿐 아니라 내부까지도 긁힘 방지 코팅이 적용되어 있습니다. 또한, 황변 방지에 최적화된 소재와 코팅 덕분에 시간이 지나도 케이스의 색상이 그대로 유지되죠.",
      "iPhone 16 Pro Max과 완벽하게 정렬을 이루는 내장 자석 덕분에 이 케이스는 언제나 마법 같은 탈부착 경험과 더 빠른 무선 충전 기능을 제공합니다. iPhone 충전 시에는 케이스를 씌운 채로 MagSafe 충전기를 착 붙이거나, Qi2 또는 Qi 인증 충전기에 올려 두면 되죠.",
      "모든 Apple 제작 케이스와 마찬가지로, 이 케이스 역시 설계 및 제조 과정 전반에서 수천 시간의 테스트를 거쳤습니다. 덕분에 멋진 디자인은 물론, 긁힘과 낙하 충격으로부터 iPhone을 보호할 수 있는 내구성도 갖추었죠.",
    ],
    in_the_box: [`MagSafe형 iPhone 16 Pro Max 투명 케이스`],
    compatible_devices: [`iPhone 16 Pro Max`],
    isNew: true,
    isSelectable: true,
    isMagSafe: true,
    isiPhone: true,
    badge: "New",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328567",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328706",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930328743",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7E4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723930332796",
      },
    ],
  },
  /* MagSafe형 iPhone 파인우븐 카드지갑 */
  {
    id: 5,
    product_name: `MagSafe형 iPhone 파인우븐 카드지갑`,
    count: 1,
    price: 85000,
    model_code: "A3323",
    overview: [
      "멋과 기능을 모두 살려 디자인된 새로운 MagSafe형 iPhone 파인우븐 카드지갑은 당신의 신분증과 신용카드를 간편하게 휴대하기에 딱 좋은 방법입니다. ‘나의 찾기’ 기능까지 지원하기 때문에 카드지갑이 당신의 폰과 분리된 경우, 알림을 받을 수 있죠.**",
      "견고한 마이크로 트윌로 제작된 소재가 이음매 없이 매끈한 질감을 선사합니다. 파인우븐 소재는 100% 포스트 컨슈머(post-consumer) 재활용 원료를 사용하기 때문에 가죽을 사용할 때보다 탄소 배출량을 대폭 감축할 수 있습니다.",
      "이 카드지갑은 강력한 자석이 내장되어 있어 iPhone 뒷면에 착 달라붙습니다. MagSafe형 케이스를 씌운 채로도 부착이 가능해 당신의 개성이 돋보이는 스타일을 만들 수 있죠. 카드를 최대 3장까지 보관할 수 있는 이 파인우븐 카드지갑은 차폐성을 갖추고 있어 신용 카드를 자성으로부터 안전하게 보호합니다",
    ],
    in_the_box: ["MagSafe형 iPhone 파인우븐 카드지갑"],
    compatible_devices: [
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
      "iPhone 14 Pro",
      "iPhone 14 Pro Max",
      "iPhone 14",
      "iPhone 14 Plus",
      "iPhone 13 Pro",
      "iPhone 13 Pro Max",
      "iPhone 13 mini",
      "iPhone 13",
      "iPhone 12 Pro",
      "iPhone 12 Pro Max",
      "iPhone 12 mini",
      "iPhone 12",
    ],
    isNew: true,
    isSelectable: false,
    isMagSafe: true,
    isiPhone: true,
    badge: "New",
    colors: [
      {
        name: "다크 그린",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6Y4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=90&.v=1723690482379",
      },
      {
        name: "블랙",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6W4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=90&.v=1723690482358",
      },
      {
        name: "딥 블루",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6X4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=90&.v=1723690482434",
      },
      {
        name: "블랙베리",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7A4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=90&.v=1723690482371",
      },
    ],
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6W4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723573541163",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6W4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723573541537",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6W4_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724181940844",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA6W4_AV3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724181940880",
      },
    ],
  },
  /* AirTag 파인우븐 키링 */
  {
    id: 6,
    product_name: "AirTag 파인우븐 키링",
    price: 58000,
    model_code: "A3363",
    overview: [
      "파인우븐 키링은 혁신적인 소재로 섬세하게 제작됩니다. 스테인리스 스틸은 강력한 만큼 근사하고, 견고한 마이크로 트윌 소재는 스웨이드 같은 느낌의 부드러운 질감을 선사하며 68% 포스트 컨슈머(post-consumer) 재활용 원료를 사용하기 때문에 가죽을 사용할 때보다 탄소 배출량을 대폭 감축할 수 있죠. 이 키링은 당신의 AirTag를 빈틈없이 감싸주기 때문에 분리될 염려도 전혀 없습니다. AirTag는 별도로 판매됩니다.",
    ],
    in_the_box: ["AirTag 파인우븐 키링"],
    compatible_devices: [],
    count: 1,
    isNew: true,
    isSelectable: false,
    isMagSafe: false,
    badge: "New",
    colors: [
      {
        name: "다크 그린",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7J4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=95&.v=1723690618119",
      },
      {
        name: "블랙",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7G4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=95&.v=1723690617884",
      },
      {
        name: "딥 블루",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7H4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=95&.v=1723690617898",
      },
      {
        name: "샤르트뢰즈",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7L4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=95&.v=1723690617884",
      },
      {
        name: "블랙베리",
        imageUrl:
          "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7K4_SW_COLOR?wid=64&hei=64&fmt=jpeg&qlt=95&.v=1723690617883",
      },
    ],
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7K4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723856728623",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7K4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723856728297",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7L4?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723856728705",
      },
      {
        id: "4",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MA7L4_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1723856728169",
      },
    ],
  },
  /* 전원 어댑터 */
  {
    id: 7,
    product_name: "20W USB-C 전원 어댑터",
    price: 28000,
    count: 1,
    model_code: "A2464",
    overview: [
      "Apple 20W USB-C 전원 어댑터는 집이나 사무실에서 혹은 이동 중에 빠르고 효율적으로 충전할 수 있게 해줍니다. iPhone 8 이후 모델과 페어링하면 급속 충전이 가능해 약 30분에 50%까지 충전할 수 있고,¹ iPad Pro 및 iPad Air와 페어링하면 최상의 충전 성능을 구현할 수 있죠. 이 어댑터는 모든 USB-C 지원 기기와 호환됩니다.",
      "충전 케이블은 별매입니다.",
    ],
    in_the_box: ["Apple 20W USB-C 전원 어댑터"],
    compatible_devices: [
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
      "iPhone 14 Pro",
      "iPhone 14 Pro Max",
      "iPhone 14",
      "iPhone 14 Plus",
      "iPhone 13 Pro",
      "iPhone 13 Pro Max",
      "iPhone 13 mini",
      "iPhone 13",
      "iPhone SE(3세대)",
      "iPhone 12 Pro",
      "iPhone 12 Pro Max",
      "iPhone 12 mini",
      "iPhone 12",
      "iPhone 11 Pro",
      "iPhone 11 Pro Max",
      "iPhone 11",
      "iPhone SE(2세대)",
      "iPhone XS",
      "iPhone XS Max",
      "iPhone XR",
      "iPhone X",
      "iPhone 8",
      "iPhone 8 Plus",
    ],
    isNew: false,
    isSelectable: false,
    isMagSafe: false,
    badge: "",
    colors: [],
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MU822?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1542407282469",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MU822_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1542407278345",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MU822_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=95&.v=1544468114955",
      },
    ],
  },
  {
    id: 8,
    product_name: "240W USB-C 충전 케이블(2m)",
    price: 45000,
    model_code: "A2794",
    overview: [
      "양 끝에 USB-C 커넥터가 달린 2m 길이의 이 우븐 디자인 충전 케이블은 USB-C 기기 간 충전, 동기화, 데이터 전송에 알맞은 제품입니다. 최대 240W 출력의 충전을 지원하며 USB 2 속도로 데이터를 전송할 수 있습니다. 이 USB-C 충전 케이블을 호환되는 USB-C 전원 어댑터와 연결하면 벽면 콘센트를 통해 편리하게 기기를 충전할 수 있고, 급속 충전 기능까지 활용할 수 있죠. USB-C 전원 어댑터는 별도로 판매됩니다.",
    ],
    in_the_box: ["Apple 240W USB-C 충전 케이블(2m)"],
    compatible_devices: [
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
    ],
    isNew: false,
    isSelectable: false,
    isMagSafe: false,
    badge: "",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MU2G3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693236163178",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MU2G3_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1693236162212",
      },
    ],
  },
  {
    id: 9,
    product_name: "60W USB-C 충전 케이블(1m)",
    price: 28000,
    model_code: "A2795",
    overview: [
      "양 끝에 USB-C 커넥터가 달린 1m 길이의 이 우븐 디자인 충전 케이블은 USB-C 기기 간 충전, 동기화, 데이터 전송에 알맞은 제품입니다. 최대 60W 출력의 충전을 지원하며 USB 2 속도로 데이터를 전송할 수 있습니다. 이 USB-C 충전 케이블을 호환되는 USB-C 전원 어댑터와 페어링하면 벽면 콘센트를 통해 편리하게 기기를 충전할 수 있고, 급속 충전 기능의 이점도 누릴 수 있습니다. USB-C 전원 어댑터는 별도로 판매합니다.",
    ],
    in_the_box: ["Apple 60W USB-C 충전 케이블(1m)"],
    compatible_devices: [
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
    ],
    isNew: false,
    isSelectable: false,
    isMagSafe: false,
    badge: "",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MQKJ3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1701898734502",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MQKJ3_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1674496556083",
      },
    ],
  },
  {
    id: 10,
    product_name: "USB-C-Lightning 어댑터",
    price: 45000,
    model_code: "A2868",
    overview: [
      "USB-C-Lightning 어댑터는 Lightning 액세서리를 USB-C 지원 iPhone 및 iPad에 연결해 한 개의 어댑터로 충전, 데이터 전송, 오디오 전송 등 세 개의 주요 기능을 손쉽게 이용할 수 있게 해줍니다. 어댑터 케이블의 외피는 편조로 짜여있어 견고함도 자랑합니다.",
      "어댑터의 USB-C 단자를 iPhone 또는 iPad의 USB-C 커넥터에 꽂은 다음, Lightning 액세서리를 연결하면 됩니다.",
      "이 어댑터는 CarPlay 지원 차량을 포함한 대부분의 자동차에서 사용 가능하며, 차량의 USB-A-Lightning 케이블을 iPhone의 USB-C 커넥터에 연결할 수 있게 해주죠. 호환 가능 옵션에 대한 더 자세한 내용은 이 문서에서 확인하세요.",
    ],
    in_the_box: ["Apple USB-C-Lightning 어댑터"],
    compatible_devices: [
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
    ],
    isNew: false,
    isSelectable: false,
    isMagSafe: false,
    badge: "",
    colors: [],
    count: 1,
    img: [
      {
        id: "1",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MUQX3?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1692831819729",
      },
      {
        id: "2",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MUQX3_AV1?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1692831818783",
      },
      {
        id: "3",
        url: "https://store.storeimages.cdn-apple.com/8756/as-images.apple.com/is/MUQX3_AV2?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1692831819191",
      },
    ],
  },
];
